/* eslint-disable @reatom/unit-naming-rule */
import { useAction, useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useMemo } from 'use-memo-one'

import { Switch } from '@blade/ui-kit'
import { incognitoModeEnabledAtom } from '@root/entities/auth'
import { reatomToggleIncognitoMode } from '@root/entities/auth/atoms'
import { InsiderIcon } from '@root/shared/ui-kit'

import { SettingsItem } from './settings-item'
import { SettingsSocials } from './settings-socials'

export const SettingsAccountAndPrivacy: React.FC = () => {
  const { t } = useTranslation()

  const [isIncognito] = useAtom(incognitoModeEnabledAtom)
  const toggleIncognitoModel = useMemo(() => reatomToggleIncognitoMode(), [])

  const toggleIncognito = useAction(toggleIncognitoModel.execute)
  const [toggleIncognitoState] = useAtom(toggleIncognitoModel)

  return (
    <Root>
      <Items>
        <SettingsItem
          // TODO: Check icon with designers
          icon={<InsiderIcon size={18} />}
          title={t('settings.incognito.label')}
          endContent={
            <Switch
              checked={isIncognito}
              disabled={toggleIncognitoState.loading}
              onCheckedChange={toggleIncognito}
            />
          }
        />

        <SettingsSocials />
      </Items>
    </Root>
  )
}

const Root = styled.div``

const Items = styled.div`
  padding: 14px;
  gap: 10px;

  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`
